import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getFeedbackCategoryList, getFeedbackListByUser } from "./Services";


export const useGetFeedbackCategoryList = () => {
  return useQuery(
    [endpoints.getFeedbackCategoryList],
    () => getFeedbackCategoryList(),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

export const useGetFeedbacksByUser = () => {
  return useQuery(
    [endpoints.getFeedbackListByUser],
    () => getFeedbackListByUser(),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
